export const NAV_GROUPS = [
  {
    label: "Overview",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: "LayoutDashboard" },
      { to: "/command-center", label: "Command Center", icon: "LayoutGrid", adminOnly: true },
      { to: "/notifications", label: "Notifications", icon: "Bell" },
    ],
  },
  {
    label: "Pipeline",
    items: [
      { to: "/crm/pipeline", label: "Pipeline Board", icon: "KanbanSquare" },
      { to: "/leads", label: "Leads", icon: "UserPlus" },
      { to: "/crm/follow-ups", label: "Follow-Ups", icon: "BellRing" },
      { to: "/crm/relationships", label: "Relationships", icon: "HeartHandshake" },
      { to: "/crm/opportunities", label: "Opportunities", icon: "Briefcase" },
      { to: "/crm/reports", label: "CRM Reports", icon: "BarChartBig", adminOnly: true },
      { to: "/consultations", label: "Consultations", icon: "CalendarHeart" },
      { to: "/cases", label: "Cases", icon: "FolderHeart" },
    ],
  },
  {
    label: "Families",
    items: [
      { to: "/families", label: "Families", icon: "Home" },
      { to: "/loved-ones", label: "Loved Ones", icon: "HeartHandshake" },
    ],
  },
  {
    label: "Service Lanes",
    items: [
      { to: "/properties", label: "Properties", icon: "Building2" },
      { to: "/placement", label: "Placement", icon: "BedDouble" },
      { to: "/home-safety", label: "Home Safety", icon: "ShieldCheck" },
      { to: "/move-mama-into-my-home", label: "Move Mama In", icon: "Users" },
      { to: "/downsizing", label: "Downsizing", icon: "PackageOpen" },
    ],
  },
  {
    label: "Network",
    items: [
      { to: "/partners", label: "Partners", icon: "Handshake" },
      { to: "/referrals", label: "Referrals", icon: "GitPullRequestArrow" },
      { to: "/external-referrals", label: "External Referrals", icon: "Handshake" },
      { to: "/reports/external-referrals", label: "Partner Reports", icon: "Gauge" },
      { to: "/external-accounts", label: "External Accounts", icon: "Building2", adminOnly: true },
      { to: "/trilogy-outreach", label: "Trilogy Outreach", icon: "Dumbbell" },
    ],
  },
  {
    label: "Work",
    items: [
      { to: "/tasks", label: "Tasks", icon: "ListChecks" },
      { to: "/chat", label: "Live Chat", icon: "MessagesSquare" },
      { to: "/meetings", label: "Meetings", icon: "Video" },
      { to: "/chat/analytics", label: "Chat Analytics", icon: "BarChart3", adminOnly: true },
      { to: "/chat/qa", label: "Q&A Review", icon: "MessageSquareText", adminOnly: true },
      { to: "/documents", label: "Document Center", icon: "FolderOpen", badge: "doc_review" },
      { to: "/documents/vault", label: "Document Vault", icon: "FileText" },
      { to: "/ai-assist", label: "AI Assistant", icon: "Sparkles" },
      { to: "/sops", label: "SOP Library", icon: "BookOpen" },
    ],
  },
  {
    label: "Business",
    items: [
      { to: "/revenue", label: "Revenue", icon: "DollarSign" },
      { to: "/reports", label: "Reports", icon: "BarChart3" },
      { to: "/reports/territories", label: "Territory Reports", icon: "MapPinned" },
    ],
  },
  {
    label: "Marketing",
    adminOnly: true,
    items: [
      { to: "/marketing", label: "Overview", icon: "Megaphone" },
      { to: "/marketing/analytics", label: "Analytics", icon: "LineChart" },
      { to: "/marketing/forms", label: "Forms", icon: "FormInput" },
      { to: "/marketing/subscribers", label: "Subscribers", icon: "Users" },
      { to: "/marketing/newsletters", label: "Newsletter", icon: "Mail" },
      { to: "/marketing/automations", label: "Automations", icon: "Workflow" },
      { to: "/marketing/email", label: "Email Activity", icon: "Send" },
      { to: "/seo-intelligence", label: "SEO Intelligence", icon: "Gauge" },
    ],
  },
  {
    label: "Admin",
    adminOnly: true,
    items: [
      { to: "/branches", label: "Branches", icon: "GitBranch" },
      { to: "/franchise-admin", label: "Franchise Manager", icon: "Building2", adminOnly: true },
      { to: "/users", label: "Users", icon: "UserCog" },
      { to: "/security", label: "Security & Compliance", icon: "ShieldCheck", adminOnly: true },
      { to: "/security/audit-logs", label: "Audit Logs", icon: "ScrollText", adminOnly: true },
      { to: "/settings/privacy-requests", label: "Privacy Requests", icon: "FileLock2", adminOnly: true },
      { to: "/security/transcript-cleanup", label: "Transcript Cleanup", icon: "Eraser", adminOnly: true },
      { to: "/settings/security-digest", label: "Security Digest", icon: "MailCheck", adminOnly: true },
      { to: "/testimonials", label: "Testimonials", icon: "MessageSquareHeart", adminOnly: true },
      { to: "/design-system", label: "Design System", icon: "Palette", superAdminOnly: true },
      { to: "/site/homepage", label: "Homepage Editor", icon: "Globe", superAdminOnly: true },
      { to: "/site/menus", label: "Menu Editor", icon: "Menu", superAdminOnly: true },
      { to: "/site/service-lanes", label: "Service Lanes", icon: "Layers", adminOnly: true },
      { to: "/site/reverse-search", label: "Reverse Search / SEO", icon: "Search", adminOnly: true },
      { to: "/site/forms", label: "Forms & Intake", icon: "FormInput", adminOnly: true },
      { to: "/site/local", label: "Local Overrides", icon: "MapPin", adminOnly: true },
      { to: "/site/faq", label: "Family FAQ", icon: "HelpCircle", adminOnly: true },
      { to: "/settings/meetings", label: "Meeting Settings", icon: "Video", adminOnly: true },
      { to: "/settings/documents", label: "Document Settings", icon: "FileCog", adminOnly: true },
      { to: "/settings/communications", label: "Communications", icon: "MessageSquareText" },
      { to: "/settings/notification-routing", label: "Notification Routing", icon: "Route", adminOnly: true },
      { to: "/settings/help-assistant", label: "Help Assistant", icon: "LifeBuoy", adminOnly: true },
      { to: "/settings", label: "Settings", icon: "Settings" },
    ],
  },
];
